package com.dotdrives.web.pages.givers

import com.dotdrives.controller.GiverDetailController
import com.dotdrives.controller.GiverDetailUiState
import com.dotdrives.web.ui.DotButton
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.textarea
import web.cssom.ClassName
import web.dom.ElementId
import web.html.InputType
import web.html.text

external interface NoteComposerProps : Props {
    var controller: GiverDetailController
    var state: GiverDetailUiState
}

val NoteComposer = FC<NoteComposerProps> { props ->
    div {
        className = ClassName("givers-composer")
        div {
            className = ClassName("givers-composer-title")
            +"Add a note"
        }
        input {
            id = ElementId("giver-note-title")
            type = InputType.text
            value = props.state.noteDraftTitle
            placeholder = "Note title (optional)"
            ariaLabel = "Note title"
            onChange = {
                props.controller.updateNoteDraft(
                    it.currentTarget.value,
                    props.state.noteDraftBody,
                )
            }
        }
        textarea {
            id = ElementId("giver-note-body")
            value = props.state.noteDraftBody
            placeholder = "What happened?"
            ariaLabel = "Note body"
            onChange = {
                props.controller.updateNoteDraft(
                    props.state.noteDraftTitle,
                    it.currentTarget.value,
                )
            }
        }
        div {
            className = ClassName("givers-composer-actions")
            DotButton {
                text = "Save note"
                onClick = props.controller::saveNote
                loading = props.state.savingNote
                enabled = props.state.noteDraftBody.isNotBlank()
                className = "givers-topbar-button"
            }
        }
    }
}
